import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import moment from "moment";

@Injectable({
	providedIn: "root",
})
export class NavigationService {
	currentPage: string;
	lastPageVisitDateTime: number;

	constructor(private router: Router) {
		this.pageChange();
	}

	async pageChange() {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				(this.currentPage = event.urlAfterRedirects), (this.lastPageVisitDateTime = moment().valueOf());
			}
		});
	}
}
